<template>
  <div class="table">
    <header-box :title="title" :intro="intro"></header-box>
    <div class="table__innerwrap">


      <div class="table__row" v-for="(table, index) in page.tables" :key="'table-'+index">
        <div class="table__table-wrap">
          <h2 class="table__table-title" v-html="table.title"></h2>
          <table class="table__table">
            <tr v-for="(row, rowIndex) in table.table.body">
              <th v-for="cell in row" v-if="rowIndex < table.table.header_rows && !cell.spanned" :colspan="cell.c_span" :rowspan="cell.r_span" v-html="cell.c"></th>
              <td v-for="(cell, cellIndex) in row" :class="{ 'odd': (cellIndex % 2), 'first': cellIndex === 0 }" v-if="rowIndex >= table.table.header_rows &&!cell.spanned" :colspan="cell.c_span" :rowspan="cell.r_span" v-html="cell.c"></td>
            </tr>
          </table>
          <p class="table__disclaimer" v-if="table.disclaimers" v-html="table.disclaimers"></p>
        </div>

        <div class="table__block" v-if="table.showContentBlock">
          <h2 class="table__block-title" v-html="table.contentBlock.title"></h2>
          <div class="table__block-content" v-html="table.contentBlock.content"></div>
        </div>
      </div>
        
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import HeaderBox from '@/components/HeaderBox';
import PrevNextNav from '@/components/PrevNextNav';

export default {
  name: 'table',
  components: { HeaderBox, PrevNextNav },
  data() {
    return {
      selectedIcon: 0,
    };
  },
  computed: {
    ...mapGetters(['page']),
    title() {
      return this.page.title;
    },
    intro() {
      return this.page.intro;
    },
  },
  methods: {
    bgImg(url) {
      return `background-image: url('${url}');`;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../../scss/helpers';

.table {
  @include page(true, true);

  &__innerwrap {
    display: flex;
    flex-direction: column;
  }

  &__push {
    flex-grow: 1;
  }

  &__row {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
    margin: 0 0 40px;
  }

  &__table-wrap {
    padding: 0 20px;
    background: $c_white;
    align-items: flex-start;
    width: 640px;
    flex-grow: 1;
    max-width: 980px;
    margin-right: 1px;

    &:nth-child(2n) {
      margin-left: 1px;
      margin-right: auto;
      align-self: flex-end;
    }
  }

  &__table-title {
    @include font-block-title;
    margin: 1.15em 0;
  }

  &__table {
    width: 100%;
    font-size: 12px;
    line-height: 16px;
    border-collapse:collapse;
    text-align: center;

    th {
      @include t_bold;
      padding: 4px 0 5px;
      background: $c_black--broken;
      color: $c_white;
      border-bottom: 1px solid $c_grey;
      line-height: 20px;

      &:not(:first-child) {
        border-left: 1px solid $c_grey;
      }
    }

    td {
      padding: 3px 0 2px;
      border-bottom: 1px solid rgba($c_primary, .3);

      &.first {
        text-align: left;
        padding-left: 10px;
      }

      &.odd {
        background: rgba($c_primary, .7);
      }

      &:not(.first) {
        border-left: 1px solid rgba($c_primary, .3);
      }

      @include font-baseline-fix;
    }
  }

  &__disclaimer {
      @include t_normal;
      font-size: 12px;
      line-height: 1.4;
      margin: 1.5em 0;
  }

  &__block {
    display: block;
    box-sizing: border-box;
    margin-bottom: 20px;
    padding: 40px 30px 30px;
    background: $c_white;

    @include tablet {
      width: 33.33%;
    }

    @include landscape {
      width: auto;
    }

    @include not-tablet {
      padding: 50px 40px 40px;
    }
  }

  &__block-title {
    @include font-block-title;
  }

  &__block-content {
    @include font-block-content;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/templates/Table.vue